const swiperPosts = {
    init() {
        this.initSliderNewPost();
        this.initSliderBlocCustomers();
        this.initSliderEngagements();
        this.initSliderActivitySector();
        this.initSliderHeader();
        this.initSliderOffers();
        this.initSliderOtherPosts();
        this.initSliderAvantage();
        this.initSliderEtapeEvolution();
        this.initSliderSponsorImage();
        this.initSliderInternalLife();

    },
    initSliderNewPost() {
        const newsPostSwiper = document.querySelector('.news-bloc-swiper');
    
        if(newsPostSwiper) {
            const newsPostSwiperSlides = newsPostSwiper.querySelectorAll('.swiper-wrapper .swiper-slide');
            const btn_nav_prev = document.querySelector('.news-section .post-btn-prev');
            const btn_nav_next = document.querySelector('.news-section .post-btn-next');
            const btn_nav_prev_swiper = document.querySelector('.news-section .swiper-btn-prev-post');
            const btn_nav_next_swiper = document.querySelector('.news-section .swiper-btn-next-post');

            if(newsPostSwiperSlides.length > 1) {
                var options = {
                    loop: true,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 45,
                    speed: 300,
                    autoHeight: false,
                    centerInsufficientSlides: true,
                    navigation: {
                        nextEl: '.swiper-btn-next-post',
                        prevEl: '.swiper-btn-prev-post',
                    },
                    pagination: {
                        el: '.swiper-pagination-post',
                        clickable: true,
                    },
                    breakpoints: {
                        375: {
                            loop: true,
                            slidesPerView: 'auto',
                            centeredSlides: true,
                            spaceBetween: 30,
                            centerInsufficientSlides: true
        
                        },
                        768: {
                            loop: true,
                            slidesPerView: 2,
                            centeredSlides: false,
                            spaceBetween: 30,
                            centerInsufficientSlides: true
                        },
                        1024: {
                            loop: true,
                            slidesPerView: 2,
                            spaceBetween: 40,
                            centeredSlides: false,
                            centerInsufficientSlides: true
                        },
                        1200: {
                            loop: false,
                            slidesPerView: 3,
                            spaceBetween: 40,
                            centeredSlides: false,
                            centerInsufficientSlides: true
                        }
                    }
                }
                const swiper = new Swiper(newsPostSwiper, options);

                if(newsPostSwiperSlides.length > 2) {
                    btn_nav_prev.style.display = "block";
                    btn_nav_next.style.display = "block";

                    btn_nav_prev.addEventListener('click', () => {
                        btn_nav_prev_swiper.click();
                        
                    })
                    btn_nav_next.addEventListener('click', () => {
                        btn_nav_next_swiper.click();
                    })
                }
                else {
                    btn_nav_prev.style.display = "none";
                    btn_nav_next.style.display = "none";
                }
            }

        }
    },
    initSliderBlocCustomers() {
        const blocCustomersSwiper = document.querySelector('.bloc-customers-swiper');

        if(blocCustomersSwiper) {
            const blocCustomersSwiperSlides = blocCustomersSwiper.querySelectorAll('.swiper-wrapper .swiper-slide');
            const btn_prev_customers = document.querySelector('.customers-section .customers-btn-prev');
            const btn_next_customers = document.querySelector('.customers-section .customers-btn-next');
            const btn_prev_customers_swiper = document.querySelector('.customers-section .btn-prev-customers');
            const btn_next_customers_swiper = document.querySelector('.customers-section .btn-next-customers');


            if(blocCustomersSwiperSlides.length > 1) {
                var options1 = {
                    loop: true,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 30,
                    speed: 300,
                    autoHeight: false,
                    centerInsufficientSlides: true,
                    autoplay : {
                        delay: 2500,
                        disableOnInteraction: false,
                    },
                    clickable: true,
                    navigation: {
                        nextEl: '.btn-next-customers',
                        prevEl: '.btn-prev-customers',
                    },
                    pagination: {
                        el: '.swiper-pagination-customers',
                        clickable: true
                    },
                    breakpoints: {
                        375: {
                            loop: true,
                            slidesPerView: 2,
                            centeredSlides: false,
                            spaceBetween: 30,
                            centerInsufficientSlides: true
        
                        },
                        768: {
                            loop: true,
                            slidesPerView: 2,
                            centeredSlides: false,
                            spaceBetween: 40,
                            centerInsufficientSlides: true
                        },
                        1024: {
                            loop: true,
                            slidesPerView: 3,
                            spaceBetween: 40,
                            centeredSlides: false,
                            centerInsufficientSlides: true
                        },
                        1200: {
                            loop: true,
                            slidesPerView: 4,
                            spaceBetween: 50,
                            centeredSlides: false,
                            centerInsufficientSlides: true
                        }
                    }
                }
                const swiper = new Swiper(blocCustomersSwiper, options1);

                btn_prev_customers.addEventListener('click', () => {
                    btn_prev_customers_swiper.click();
                })
                btn_next_customers.addEventListener('click', () => {
                    btn_next_customers_swiper.click();
                })
            }
            
        }
    },
    initSliderEngagements() {
        const swiperEngagements = document.querySelector('.engagements-swiper');

        if(swiperEngagements) {
            const swiperEngagementsSwiperSlides = swiperEngagements.querySelectorAll('.swiper-wrapper .swiper-slide');
            const btn_prev_engagements = document.querySelector('.engagements-section .engagements-btn-prev');
            const btn_next_engagements = document.querySelector('.engagements-section .engagements-btn-next');
            const btn_prev_engagements_swiper = document.querySelector('.engagements-section .btn-prev-engagements');
            const btn_next_engagements_swiper = document.querySelector('.engagements-section .btn-next-engagements');

            if(swiperEngagementsSwiperSlides.length > 1) {
                var options9 = {
                    loop: true,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 30,
                    speed: 300,
                    autoHeight: false,
                    centerInsufficientSlides: true,
                    autoplay : {
                        delay: 2500,
                        disableOnInteraction: false,
                    },
                    clickable: true,
                    navigation: {
                        nextEl: '.btn-next-engagements',
                        prevEl: '.btn-prev-engagements',
                    },
                    pagination: {
                        el: '.swiper-pagination-engagements',
                        clickable: true
                    },
                    breakpoints: {
                        375: {
                            loop: true,
                            slidesPerView: 2,
                            centeredSlides: false,
                            spaceBetween: 30,
                            centerInsufficientSlides: true
        
                        },
                        768: {
                            loop: true,
                            slidesPerView: 2,
                            centeredSlides: false,
                            spaceBetween: 40,
                            centerInsufficientSlides: true
                        },
                        1024: {
                            loop: true,
                            slidesPerView: 3,
                            spaceBetween: 40,
                            centeredSlides: false,
                            centerInsufficientSlides: true
                        },
                        1200: {
                            loop: true,
                            slidesPerView: 4,
                            spaceBetween: 50,
                            centeredSlides: false,
                            centerInsufficientSlides: true
                        }
                    }
                }
                const swiper = new Swiper(swiperEngagements, options9);

                btn_prev_engagements.addEventListener('click', () => {
                    btn_prev_engagements_swiper.click();
                })
                btn_next_engagements.addEventListener('click', () => {
                    btn_next_engagements_swiper.click();
                })
            }
            
        }
    },
    initSliderActivitySector() {
        const activitySectorSwiper = document.querySelector('.activities-list-swiper')

        var options3 = {
            loop: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 30,
            speed: 300,
            autoHeight: false,
            centerInsufficientSlides: true,

            navigation: {
                nextEl: '.swiper-btn-next-activity',
                prevEl: '.swiper-btn-prev-activity'
            },
            pagination: {
                el: '.swiper-pagination-activity'
            },
            breakpoints: {
                375: {
                    loop: true,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 30,
                    centerInsufficientSlides: true

                },
                768: {
                    loop: true,
                    slidesPerView: 'auto',
                    centeredSlides: false,
                    spaceBetween: 40,
                    centerInsufficientSlides: true
                },
                1024: {
                    loop: true,
                    slidesPerView: 4,
                    spaceBetween: 40,
                    centeredSlides: false,
                    centerInsufficientSlides: true
                },
                1280: {
                    loop: false,
                    slidesPerView: 6,
                    spaceBetween: 50,
                    centeredSlides: false,
                    centerInsufficientSlides: true
                }
            }
        }

        if(activitySectorSwiper) {

            const activitySectorSwiperSlides = activitySectorSwiper.querySelectorAll('.swiper-wrapper .swiper-slide');
            const btn_prev_activity = document.querySelector('.activities-section .activity-btn-prev');
            const btn_next_activity = document.querySelector('.activities-section .activity-btn-next');
            const btn_prev_activity_swiper = document.querySelector('.activities-section .swiper-btn-prev-activity');
            const btn_next_activity_swiper = document.querySelector('.activities-section .swiper-btn-next-activity');
            
            
            if(activitySectorSwiperSlides.length > 1) {
                
                const swiper = new Swiper(activitySectorSwiper, options3);

                btn_prev_activity.addEventListener('click', () => {
                    btn_prev_activity_swiper.click();
                })
                btn_next_activity.addEventListener('click', () => {
                    btn_next_activity_swiper.click();
                })
            }
            
        }
    },
    initSliderHeader() {
        var options5 = {
            loop: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 30,
            speed: 1000,
            effect: "fade",
            simulateTouch: false,
            autoplay: {
                delay: 4000,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: '.swiper-header-next',
                prevEl: '.swiper-header-prev'
            },
            pagination: {
                el: '.swiper-header-pagination',
            },
            breakpoints: {
                375: {
                    loop: true,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 30,
                    centerInsufficientSlides: true

                },
                768: {
                    loop: true,
                    slidesPerView: 'auto',
                    centeredSlides: false,
                    spaceBetween: 40,
                    centerInsufficientSlides: true
                },
                1024: {
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: 40,
                    centeredSlides: false,
                    centerInsufficientSlides: true
                },
                1280: {
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: 50,
                    centeredSlides: false,
                    centerInsufficientSlides: true
                }
            }

        }
        const headerSwiper = document.querySelector('.header-swiper');

        if(headerSwiper) {
            const swiperHeader = new Swiper(headerSwiper, options5);            
            
            const btn_swiper_header_prev = document.querySelector('.header-swiper .swiper-header-prev');
            const btn_swiper_header_next = document.querySelector('.header-swiper .swiper-header-next');
            const btn_header_btn_prev = document.querySelector('.header-swiper .header-btn-prev');
            const btn_header_btn_next = document.querySelector('.header-swiper .header-btn-next');
            
            btn_header_btn_prev.addEventListener('click', () => {
                btn_swiper_header_prev.click();
            })
            btn_header_btn_next.addEventListener('click', () => {
                btn_swiper_header_next.click();
            })
            
        }
    },
    initSliderOffers() {
        const offerSwiper = document.querySelector('.offers-swiper');

        var options6 = {
            loop: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 50,
            navigation: {
                nextEl: '.swiper-btn-next-offers-section',
                prevEl: '.swiper-btn-prev-offers-section'
            },
            pagination: {
                el: '.swiper-pagination-offers-section',
            },
            breakpoints: {
                375: {
                    loop: true,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 50,
                    centerInsufficientSlides: true

                },
                768: {
                    loop: true,
                    slidesPerView: 'auto',
                    centeredSlides: false,
                    spaceBetween: 50,
                    centerInsufficientSlides: true
                },
                1024: {
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: 50,
                    centeredSlides: false,
                    centerInsufficientSlides: true
                },
                1280: {
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: 50,
                    centeredSlides: false,
                    centerInsufficientSlides: true
                }
            }

        }
        if(offerSwiper) {
            const swiperOffer = new Swiper(offerSwiper, options6);    
            const btn_swiper_offers_prev = document.querySelector('.offers-swiper .swiper-btn-prev-offers-section');
            const btn_swiper_offers_next = document.querySelector('.offers-swiper .swiper-btn-next-offers-section');
            const btn_offers_btn_prev = document.querySelector('.offers-bloc-content .offers-btn-prev-section');
            const btn_offers_btn_next = document.querySelector('.offers-bloc-content .offers-btn-next-section');
            
            btn_offers_btn_prev.addEventListener('click', () => {
                btn_swiper_offers_prev.click();
            });

            btn_offers_btn_next.addEventListener('click', () => {
                btn_swiper_offers_next.click();
            });
    
        }
    },
    initSliderOtherPosts() {
        const otherPostsSwiper = document.querySelector('.other-posts-swiper');
        var options7 = {
            loop: false,
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 50,
            speed: 300,
            autoHeight: false,
            centerInsufficientSlides: true,

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                
                769: {
                    loop: true,
                    slidesPerView: 2,
                    spaceBetween: 40,
                    centeredSlides: false,
                    centerInsufficientSlides: true
                }

            }
        }
        
        
        if(otherPostsSwiper)  {         

            const otherPostSwiperSlides = otherPostsSwiper.querySelectorAll('.swiper-wrapper .swiper-slide');
            const btn_other_posts_btn_prev = document.querySelector('.other-posts .container .other-post-btn-prev');
            const btn_other_posts_btn_next = document.querySelector('.other-posts .container .other-post-btn-next');
            const otherPostSwiperWrapper = otherPostsSwiper.querySelector('.swiper-wrapper');
            
            if(otherPostSwiperSlides.length > 1) {
                const swiperOtherPosts = new Swiper(otherPostsSwiper, options7);    
                
                const btn_swiper_other_posts_prev = document.querySelector('.other-posts-swiper .swiper-button-prev');
                const btn_swiper_other_posts_next = document.querySelector('.other-posts-swiper .swiper-button-next');
                
            

                btn_other_posts_btn_prev.addEventListener('click', () => {
                    btn_swiper_other_posts_prev.click();
                })
                btn_other_posts_btn_next.addEventListener('click', () => {
                    btn_swiper_other_posts_next.click();
                })
    
            }
            else {

                otherPostSwiperWrapper.style.justifyContent = "center";

                otherPostSwiperSlides.forEach(e => {
                    e.style.maxWidth = "50%";
                })

                
                btn_other_posts_btn_next.style.display = "none";
                btn_other_posts_btn_prev.style.display = "none";
            }
        } 
    },
    initSliderAvantage() {
        const avantagesSwiper = document.querySelector('.avantages-swiper');
        var options8 = {
            loop: true,
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 0,
            speed: 300,
            autoHeight: false,
            centerInsufficientSlides: true,

            navigation: {
                nextEl: '.next-btn-avantages',
                prevEl: '.prev-btn-avantages',
            },
            breakpoints: {
                
                480: {
                    loop: true,
                    slidesPerView: 2,
                    spaceBetween: 20,
                    centeredSlides: false,
                    centerInsufficientSlides: true
                },

                768: {
                    loop: true,
                    slidesPerView: 3,
                    spaceBetween: 20,
                    centeredSlides: false,
                    centerInsufficientSlides: true
                },

                1024: {
                    loop: false,
                    slidesPerView: 5,
                    spaceBetween: 30,
                    centeredSlides: false,
                    centerInsufficientSlides: true
                }

            }
        }

        if(avantagesSwiper)  {    
                
            const swiperAvantages = new Swiper(avantagesSwiper, options8);    
            
            const btn_swiper_avantages_prev = document.querySelector('.avantages-swiper .swiper-button-prev');
            const btn_swiper_avantages_next = document.querySelector('.avantages-swiper .swiper-button-next');
            const btn_avantages_btn_prev = document.querySelector('.avantages-content .avantages-btn-prev');
            const btn_avantages_btn_next = document.querySelector('.avantages-content .avantages-btn-next');
            
            btn_avantages_btn_prev.addEventListener('click', () => {
                btn_swiper_avantages_prev.click();
            })
            btn_avantages_btn_next.addEventListener('click', () => {
                btn_swiper_avantages_next.click();
            })
        } 
    },
    initSliderEtapeEvolution() {
        const evolutionSwiper = document.querySelector('.evolution-swiper');
        var options9 = {
            loop: true,
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 15,
            speed: 300,
            autoHeight: false,
            centerInsufficientSlides: true,
            loopFillGroupWithBlank: true,
            loopAdditionalSlides: 100,
            allowTouchMove: false,
            navigation: {
                nextEl: '.next-btn-evolution',
                prevEl: '.prev-btn-evolution',
            },
            breakpoints: {
                
                480: {
                    loop: true,
                    slidesPerView: 1,
                    centeredSlides: false,
                    spaceBetween: 30,
                    speed: 300,
                    autoHeight: false,
                    centerInsufficientSlides: true,
                    loopFillGroupWithBlank: true,
                    loopAdditionalSlides: 100,
                },

                768: {
                    loop: true,
                    slidesPerView: 1,
                    centeredSlides: false,
                    spaceBetween: 30,
                    speed: 300,
                    autoHeight: false,
                    centerInsufficientSlides: true,
                    loopFillGroupWithBlank: true,
                    loopAdditionalSlides: 100,
                },

                1024: {
                    loop: true,
                    slidesPerView: 1,
                    centeredSlides: false,
                    spaceBetween: 50,
                    speed: 300,
                    autoHeight: false,
                    centerInsufficientSlides: true,
                    loopFillGroupWithBlank: true,
                    loopAdditionalSlides: 100,
                },

                1200: {
                    loop: true,
                    slidesPerView: 1,
                    centeredSlides: false,
                    spaceBetween: 115,
                    speed: 300,
                    autoHeight: false,
                    centerInsufficientSlides: true,
                    loopFillGroupWithBlank: true,
                    loopAdditionalSlides: 100,
                }

            }
        }

        if(evolutionSwiper)  {    
            
            const swiperEvolution = new Swiper(evolutionSwiper, options9);    
            
            const btn_swiper_evolution_prev = document.querySelector('.evolution-swiper .swiper-button-prev');
            const btn_swiper_evolution_next = document.querySelector('.evolution-swiper .swiper-button-next');
            const btn_evolution_btn_prev = document.querySelector('.evolution-content .evolution-btn-prev');
            const btn_evolution_btn_next = document.querySelector('.evolution-content .evolution-btn-next');
            
            animBar();

            btn_evolution_btn_prev.addEventListener('click', () => {
                btn_swiper_evolution_prev.click();
                animBar();
            })
            btn_evolution_btn_next.addEventListener('click', () => {
                btn_swiper_evolution_next.click();
                animBar();
            })
        } 


        function animBar() {
            const swiperSlideActive = document.querySelector('.evolution-swiper .evolution-wrapper .etape.swiper-slide-active');
            const progressWrapper = swiperSlideActive.querySelector('.progress-wrapper');
            const progressBar = swiperSlideActive.querySelector('.progress-bar');
            const percent = progressBar.querySelector('.percent');
            const percentNumber = progressBar.querySelector('.percent .percent-number');
            const percentNumberSpan = percentNumber.querySelector('.span-percent');
            const behindBar = progressWrapper.querySelector('.behind-bar');
            const text = progressWrapper.querySelector('.text');

            const swiperSlidePrev = document.querySelector('.evolution-swiper .evolution-wrapper .etape.swiper-slide-prev');
            const progressWrapperPrev = swiperSlidePrev.querySelector('.progress-wrapper');
            const progressBarPrev = swiperSlidePrev.querySelector('.progress-bar');
            const percentPrev = progressBarPrev.querySelector('.percent');
            const percentNumberPrev = progressBarPrev.querySelector('.percent .percent-number');
            // const percentNumberPrevSpan = percentNumberPrev.querySelector('.span-percent');
            const textPrev = progressWrapperPrev.querySelector('.text');

            let valPrev = textPrev.offsetWidth + progressBarPrev.offsetWidth;
            let resultPrev = swiperSlidePrev.clientWidth - valPrev;
            let paddingWidthPrev = resultPrev / 2
            let calPrev = progressBarPrev.offsetWidth - percentPrev.offsetWidth;

            let behindStart = paddingWidthPrev + calPrev + "px";
            behindBar.style.width = paddingWidthPrev + calPrev + 'px';

            let val1 = text.offsetWidth + progressBar.offsetWidth;
            let result1 = swiperSlideActive.clientWidth - val1;
            let paddingWidth = result1 / 2
            let cal = progressBar.offsetWidth - percent.offsetWidth;
            var behindCurrent = paddingWidth + cal + 'px';
            var widthStart = percentPrev.offsetWidth;
            var widthEnd = percent.offsetWidth;

            if(widthStart > widthEnd) {
                widthStart = 0;
            }

            if(behindCurrent > behindStart ) {
                behindStart = cal + paddingWidth + percent.offsetWidth  + "px";
            }

            var tl = gsap.timeline({});
            tl
            .fromTo(percent, {width: widthStart+"px" } , {duration: 2 , width: widthEnd+"px", ease : "power3.out"})
            .fromTo(behindBar , {width : behindStart} , {duration : 2, width : behindCurrent, ease : "power3.out"}, 0 )
            
            var __assign =
            (this && this.__assign) ||
            function () {
                return (__assign =
                    Object.assign ||
                    function (t) {
                        for (var i, s = 1, n = arguments.length; s < n; s++) for (var a in (i = arguments[s])) Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);
                        return t;
                    }).apply(this, arguments);
            },
            CountUp = (function () {
                function t(t, i, s) {
                    var n = this;
                    (this.endVal = i),
                        (this.options = s),
                        (this.version = "2.4.2"),
                        (this.defaults = {
                            startVal: 0,
                            decimalPlaces: 0,
                            duration: 2,
                            useEasing: !0,
                            useGrouping: !0,
                            useIndianSeparators: !1,
                            smartEasingThreshold: 999,
                            smartEasingAmount: 500,
                            separator: ",",
                            decimal: ".",
                            prefix: "",
                            suffix: "",
                            enableScrollSpy: !1,
                            scrollSpyDelay: 200,
                            scrollSpyOnce: !1,
                        }),
                        (this.finalEndVal = null),
                        (this.useEasing = !0),
                        (this.countDown = !1),
                        (this.error = ""),
                        (this.startVal = 0),
                        (this.paused = !0),
                        (this.once = !1),
                        (this.count = function (t) {
                            n.startTime || (n.startTime = t);
                            var i = t - n.startTime;
                            (n.remaining = n.duration - i),
                                n.useEasing
                                    ? n.countDown
                                        ? (n.frameVal = n.startVal - n.easingFn(i, 0, n.startVal - n.endVal, n.duration))
                                        : (n.frameVal = n.easingFn(i, n.startVal, n.endVal - n.startVal, n.duration))
                                    : (n.frameVal = n.startVal + (n.endVal - n.startVal) * (i / n.duration));
                            var s = n.countDown ? n.frameVal < n.endVal : n.frameVal > n.endVal;
                            (n.frameVal = s ? n.endVal : n.frameVal),
                                (n.frameVal = Number(n.frameVal.toFixed(n.options.decimalPlaces))),
                                n.printValue(n.frameVal),
                                i < n.duration ? (n.rAF = requestAnimationFrame(n.count)) : null !== n.finalEndVal ? n.update(n.finalEndVal) : n.callback && n.callback();
                        }),
                        (this.formatNumber = function (t) {
                            i = Math.abs(t).toFixed(n.options.decimalPlaces);
                            var i,
                                s,
                                a,
                                e,
                                r = (i += "").split(".");
                            if (((s = r[0]), (a = r.length > 1 ? n.options.decimal + r[1] : ""), n.options.useGrouping)) {
                                e = "";
                                for (var o = 3, l = 0, h = 0, u = s.length; h < u; ++h) n.options.useIndianSeparators && 4 === h && ((o = 2), (l = 1)), 0 !== h && l % o == 0 && (e = n.options.separator + e), l++, (e = s[u - h - 1] + e);
                                s = e;
                            }
                            return (
                                n.options.numerals &&
                                    n.options.numerals.length &&
                                    ((s = s.replace(/[0-9]/g, function (t) {
                                        return n.options.numerals[+t];
                                    })),
                                    (a = a.replace(/[0-9]/g, function (t) {
                                        return n.options.numerals[+t];
                                    }))),
                                (t < 0 ? "-" : "") + n.options.prefix + s + a + n.options.suffix
                            );
                        }),
                        (this.easeOutExpo = function (t, i, s, n) {
                            return (s * (-Math.pow(2, (-10 * t) / n) + 1) * 1024) / 1023 + i;
                        }),
                        (this.options = __assign(__assign({}, this.defaults), s)),
                        (this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber),
                        (this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo),
                        (this.startVal = this.validateValue(this.options.startVal)),
                        (this.frameVal = this.startVal),
                        (this.endVal = this.validateValue(i)),
                        (this.options.decimalPlaces = Math.max(this.options.decimalPlaces)),
                        this.resetDuration(),
                        (this.options.separator = String(this.options.separator)),
                        (this.useEasing = this.options.useEasing),
                        "" === this.options.separator && (this.options.useGrouping = !1),
                        (this.el = "string" == typeof t ? document.getElementById(t) : t),
                        this.el ? this.printValue(this.startVal) : (this.error = "[CountUp] target is null or undefined"),
                        "undefined" != typeof window &&
                            this.options.enableScrollSpy &&
                            (this.error
                                ? console.error(this.error, t)
                                : ((window.onScrollFns = window.onScrollFns || []),
                                window.onScrollFns.push(function () {
                                    return n.handleScroll(n);
                                }),
                                (window.onscroll = function () {
                                    window.onScrollFns.forEach(function (t) {
                                        return t();
                                    });
                                }),
                                this.handleScroll(this)));
                }
                return (
                    (t.prototype.handleScroll = function (t) {
                        if (t && window && !t.once) {
                            var i = window.innerHeight + window.scrollY,
                                s = t.el.getBoundingClientRect(),
                                n = s.top + window.pageYOffset,
                                a = s.top + s.height + window.pageYOffset;
                            a < i && a > window.scrollY && t.paused
                                ? ((t.paused = !1),
                                setTimeout(function () {
                                    return t.start();
                                }, t.options.scrollSpyDelay),
                                t.options.scrollSpyOnce && (t.once = !0))
                                : (window.scrollY > a || n > i) && !t.paused && t.reset();
                        }
                    }),
                    (t.prototype.determineDirectionAndSmartEasing = function () {
                        var t = this.finalEndVal ? this.finalEndVal : this.endVal;
                        if (((this.countDown = this.startVal > t), Math.abs(t - this.startVal) > this.options.smartEasingThreshold && this.options.useEasing)) {
                            this.finalEndVal = t;
                            var i = this.countDown ? 1 : -1;
                            (this.endVal = t + i * this.options.smartEasingAmount), (this.duration = this.duration / 2);
                        } else (this.endVal = t), (this.finalEndVal = null);
                        null !== this.finalEndVal ? (this.useEasing = !1) : (this.useEasing = this.options.useEasing);
                    }),
                    (t.prototype.start = function (t) {
                        !this.error && ((this.callback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), (this.paused = !1), (this.rAF = requestAnimationFrame(this.count))) : this.printValue(this.endVal));
                    }),
                    (t.prototype.pauseResume = function () {
                        this.paused
                            ? ((this.startTime = null), (this.duration = this.remaining), (this.startVal = this.frameVal), this.determineDirectionAndSmartEasing(), (this.rAF = requestAnimationFrame(this.count)))
                            : cancelAnimationFrame(this.rAF),
                            (this.paused = !this.paused);
                    }),
                    (t.prototype.reset = function () {
                        cancelAnimationFrame(this.rAF), (this.paused = !0), this.resetDuration(), (this.startVal = this.validateValue(this.options.startVal)), (this.frameVal = this.startVal), this.printValue(this.startVal);
                    }),
                    (t.prototype.update = function (t) {
                        cancelAnimationFrame(this.rAF),
                            (this.startTime = null),
                            (this.endVal = this.validateValue(t)),
                            this.endVal !== this.frameVal &&
                                ((this.startVal = this.frameVal), null == this.finalEndVal && this.resetDuration(), (this.finalEndVal = null), this.determineDirectionAndSmartEasing(), (this.rAF = requestAnimationFrame(this.count)));
                    }),
                    (t.prototype.printValue = function (t) {
                        var i = this.formattingFn(t);
                        this.el && ("INPUT" === this.el.tagName ? (this.el.value = i) : "text" === this.el.tagName || "tspan" === this.el.tagName ? (this.el.textContent = i) : (this.el.innerHTML = i));
                    }),
                    (t.prototype.ensureNumber = function (t) {
                        return "number" == typeof t && !isNaN(t);
                    }),
                    (t.prototype.validateValue = function (t) {
                        var i = Number(t);
                        return this.ensureNumber(i) ? i : ((this.error = "[CountUp] invalid start or end value: ".concat(t)), null);
                    }),
                    (t.prototype.resetDuration = function () {
                        (this.startTime = null), (this.duration = 1e3 * Number(this.options.duration)), (this.remaining = this.duration);
                    }),
                    t
                );
            })();
            // export { CountUp };
            
            if(parseInt(percentNumberPrev.dataset.percent) > parseInt(percentNumber.dataset.percent)) {
                var startCount = 0;
            }
            else {
                startCount = parseInt(percentNumberPrev.dataset.percent)
            }

            const optionsCount = {
                startVal: startCount,
            };

            let demo = new CountUp(percentNumberSpan, parseInt(percentNumber.dataset.percent), optionsCount);
            if (!demo.error) {
                demo.start();
            } else {
                console.error(demo.error);
            }


        }
    },
    initSliderSponsorImage() {
        const sponsorSwiper = document.querySelector('.sponsor-swiper');
        var options10 = {
            speed: 1000,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 3000,
            }
        }

        if(sponsorSwiper) {
            const swiperSponsor = new Swiper(sponsorSwiper, options10);    
        }
    },
    initSliderInternalLife() {
        const internalLifeSwiper = document.querySelectorAll('.internal-life-swiper');
        // console.log(internalLifeSwiper);
        var options11 = {
            loop: true,
            speed: 1000,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 3000,
            },
            centerInsufficientSlides: true,
            // navigation: {
            //     nextEl: '.swiper-button-next-intern',
            //     prevEl: '.swiper-button-prev-intern',
            // }
        }

        if(internalLifeSwiper) {
            let cpt = 0;
            internalLifeSwiper.forEach( e => {
                let internalLifeSwiperSlides = e.querySelectorAll('.swiper-wrapper .swiper-slide');

                if(internalLifeSwiperSlides.length > 1) {
                    new Swiper(internalLifeSwiper[cpt], options11);
                    
                }
                cpt++;
                // console.log(internalLifeSwiperSlides.length);
                
            }); 
        }
    }
    
}

export default swiperPosts;